import recordCamera from './RecordCamera.png';

const RecordCameraIcon = () => {
    return <img src={recordCamera} alt="G icon" width="63px" height="46px" />;
};

export default RecordCameraIcon;